export default function (RestangularProvider, $windowProvider) {
    RestangularProvider.setErrorInterceptor(function(response, deferred, responseHandler) {
        if(response.status == '401' && (response.data == 'invalid_grant' || response.data.error == 'invalid_grant')){
            RemoveData();
            $windowProvider.$get().location.href = '#/login';
            return false;
        }
    });

};


/** WEBPACK FOOTER **
 ** ./js/config/error_interceptor.js
 **/